import * as motion from "motion/react-client"
import { Link } from 'react-router-dom';
import StickyNavbar from '../navbar';
import honesty from '../images/honesty.png';
import reliability from '../images/reliability.png';
import objectivity from '../images/objectivity.png';
import openness from '../images/openness.png';
import duty from '../images/duty.png';
import fairness from '../images/fairness.png';
import responsibility from '../images/responsibility.png';


const SectionOne = () => {
  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 },
    },
  };

  return (
    <div>
      <StickyNavbar />
      <div className="bg-white space-y-10 text-black p-4 lg:mt-10 mt-20 sm:p-10 lg:px-20 text-lg">
        {/* Why do we do research? */}
        <motion.div
          className="space-y-3"
          initial="hidden"
          animate="visible"
          variants={staggerContainer}
        >
          <motion.h1
            className="text-3xl lg:text-4xl font-bold text-center capitalize"
            variants={fadeIn}
          >
            Why do we do Research?
          </motion.h1>

          <motion.h2
            className="text-xl font-bold mb-2 text-[#005FFF] "
            variants={fadeIn}
          >
            ❖ To Solve Problems
          </motion.h2>

          <motion.p variants={fadeIn}>
            Research can help us find answers to everyday health problems. It is
            important for developing new treatments or strategies that can make a
            direct impact on people's lives...
          </motion.p>

          <motion.p variants={fadeIn}>
            For example, if there is a lot of malaria in the community...
          </motion.p>

          <motion.p variants={fadeIn}>
            Research helps us to explain events and why certain things happen...
          </motion.p>
        </motion.div>

        {/* Guiding Principles */}
        <motion.div
          className="space-y-3"
          initial="hidden"
          animate="visible"
          variants={staggerContainer}
        >
          <motion.h2
            className="text-xl font-bold mb-2 text-[#005FFF] "
            variants={fadeIn}
          >
          ❖  Guiding Principles
          </motion.h2>

          <motion.p variants={fadeIn}>
            You will find lots of different lists of guidelines to follow...
          </motion.p>

          <motion.ul className="list-none" variants={staggerContainer}>
            <motion.li className="flex items-start space-x-3" variants={fadeIn}>
              <img
                src={honesty}
                alt="bullet"
                className="w-6 h-6 mt-1"
              />
              <p>
                <strong>Honesty:</strong> We should always report the truth about
                what we find when we do research...
              </p>
            </motion.li>
            <motion.li className="flex items-start space-x-3" variants={fadeIn}>
              <img
                src={reliability}
                alt="bullet"
                className="w-6 h-6 mt-1"
              />
              <p>
                <strong>Reliability:</strong> Following the proper methods of doing
                research means that what we find can be trusted by others...
              </p>
            </motion.li>
            <motion.li className="flex items-start space-x-3" variants={fadeIn}>
              <img
                src={objectivity}
                alt="bullet"
                className="w-6 h-6 mt-1"
              />
              <p>
                <strong>Objectivity:</strong> We need to keep a balanced view while
                doing research...
              </p>
            </motion.li>
            <motion.li className="flex items-start space-x-3" variants={fadeIn}>
              <img
                src={openness}
                alt="bullet"
                className="w-6 h-6 mt-1"
              />
              <p>
                <strong>Openness:</strong> Share your research findings with the
                community...
              </p>
            </motion.li>
            <motion.li className="flex items-start space-x-3" variants={fadeIn}>
              <img
                src={duty}
                alt="bullet"
                className="w-6 h-6 mt-1"
              />
              <p>
                <strong>Duty of Care:</strong> Consider how your research impacts
                individuals, communities, and the environment...
              </p>
            </motion.li>
            <motion.li className="flex items-start space-x-3" variants={fadeIn}>
              <img
                src={fairness}
                alt="bullet"
                className="w-6 h-6 mt-1"
              />
              <p>
                <strong>Fairness:</strong> Treat every individual involved in the
                research process with respect...
              </p>
            </motion.li>
            <motion.li className="flex items-start space-x-3" variants={fadeIn}>
              <img
                src={responsibility}
                alt="bullet"
                className="w-6 h-6 mt-1"
              />
              <p>
                <strong>Responsibility to future people:</strong> Reflect on the
                long-term effects of your research...
              </p>
            </motion.li>
          </motion.ul>
        </motion.div>

        {/* Who does research? */}
        <motion.div
          initial="hidden"
          animate="visible"
          variants={staggerContainer}
        >
          <motion.h2
            className="text-xl font-bold mb-2 text-[#005FFF] "
            variants={fadeIn}
          >
          ❖  Who does research?
          </motion.h2>

          <motion.ul className="list-disc list-inside" variants={fadeIn}>
            <li>List of everyone who can do research</li>
            <li>CHW’s - include a picture of CHW in front of pregnant women</li>
          </motion.ul>
        </motion.div>

        {/* Navigation Buttons */}
        <div className="flex justify-between mt-10">
          <Link to="/chapter1">
            <motion.button
              className="bg-blue-900 text-white px-6 py-2 rounded-lg hover:bg-blue-700"
              whileHover={{ scale: 1.1 }}
            >
              Previous
            </motion.button>
          </Link>
          <Link to="/chapter1/sectionTwo">
            <motion.button
              className="bg-blue-900 text-white px-6 py-2 rounded-lg hover:bg-blue-700"
              whileHover={{ scale: 1.1 }}
            >
              Next
            </motion.button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SectionOne;
